import { HolidayList } from 'modules/holiday/components/HolidayList';
import React, { FunctionComponent } from 'react';

type ProHolidaysRouteProps = {
  proViewId: number;
};

const ProHolidaysRoute: FunctionComponent<ProHolidaysRouteProps> = ({
  proViewId,
}) => <HolidayList viewId={proViewId} />;

export default ProHolidaysRoute;
